export const EXCLUDED_JOB_CONTRACT_NAMES = [
	'vie',
	'freelance',
	'statutaire',
	'franchise',
];

export const FULL_TIME_JOB_TYPE_LABEL = 'temps plein';
